import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import LinkDetails from './LinkDetails';

const Link = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.key} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(link|link/start)"
                            name="LinkDetails"
                            exact
                            component={LinkDetails}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Link;



// WEBPACK FOOTER //
// ./src/containers/Link/Link.jsx